// extracted by mini-css-extract-plugin
export default {"cls1":"AboutTheAuthorsSection-cls1_djy","cls2":"AboutTheAuthorsSection-cls2_sMy AboutTheAuthorsSection-cls1_djy"};